var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 120,
    viewBox: "0 0 99 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_838_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3796 6.75322L-18.613 44.9265C-25.3688 47.64 -25.3297 51.4087 -19.8525 53.0893L5.56288 61.0176L64.3665 23.9164C67.147 22.2246 69.6875 23.1347 67.5993 24.9884L19.9567 67.9856H19.9455L19.9567 67.9912L18.2035 94.1882C20.7719 94.1882 21.9053 93.0101 23.3458 91.6199L35.6905 79.6157L61.3683 98.5823C66.103 101.19 69.5032 99.8497 70.6813 94.1994L87.5374 14.7597C89.2626 7.84197 84.8965 4.70972 80.3796 6.75322Z",
    fill: "#FC6432",
    fillOpacity: 0.29
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_838_339",
    x: -27.8312,
    y: 2.13696,
    width: 119.754,
    height: 101.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_838_339"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramVector);
export default __webpack_public_path__ + "static/media/telegram-vector.9f1714968b479b0e832557f66e07e19e.svg";
export { ForwardRef as ReactComponent };